<template>
	<div class="default-content-block" :class="type" :style="contentBlockStyle">
		<component
			:is="headindLevel"
			class="default-content-block__title"
			:style="titleStyle"
		>
			{{ title }}
		</component>
		<slot name="list"></slot>
		<div class="default-content-block__desc" v-html="desc"></div>
		<slot name="button"></slot>
		<slot name="ornement"></slot>
		<slot name="links"></slot>
		<slot name="animation"></slot>
	</div>
</template>

<script>
export default {
	name: 'DefaultContentBlock',

	props: {
		title: { type: String, required: true, default: 'placeholder' },
		desc: { type: String, required: true, default: 'placeholder' },
		type: { type: String, required: false, default: null },
		titleColor: { type: String, required: false, default: '-transparent' },
		fontColor: { type: String, required: false, default: 'black' },
		headindLevel: { type: String, required: false, default: 'h3' },
		id: { type: String, required: false, default: null },
	},

	computed: {
		contentBlockStyle() {
			return {
				color: this.fontColor,
			};
		},
		titleStyle() {
			return {
				color: this.titleColor,
			};
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped></style>
